const riparazioni_bytewood = {
    state: {
        component: 'Index',
        edit: false,
        all: []
    },
    mutations: {
        CHANGE_RIPARAZIONI_BYTEWOOD_COMPONENT(state, payload) {
            state.component = payload
        },
        CHANGE_RIPARAZIONI_BYTEWOOD_EDIT(state, payload) {
            state.edit = payload
        }
    },
    getters: {
        getRiparazioniBytewoodComponent: state => state.component,
        getRiparazioniBytewoodEdit: state => state.edit
    }
}

export default riparazioni_bytewood